import classnames from "classnames";
import React, { useContext } from "react";
import {
  RicosDirectionHandledContextProvider,
  RicosNodeContext,
  RicosNodeContextProvider,
  RicosViewerContext,
  VisibleIndentationContext
} from "./../../../../../ricos-context";
import { TextStyle_TextAlignment } from "./../../../../../ricos-schema/legacy/wix/rich_content/v1";
import {
  Decoration_Type,
  Node_Type
} from "./../../../../../ricos-types";
import { getListSymbol, normalizeOffset } from "./../../../../../wix-rich-content-common";
import { getPaywallSeoClass, isPaywallSeo } from "../../utils/paywallSeo";
import { levelToClassName } from "../heading/heading";
import { getStartMargin } from "./getStartMargin";
import styles from "./lists-scss";
const ListItem = ({ node, nodeIndex, RicosNodesRenderer }) => {
  const { seoMode } = useContext(RicosViewerContext);
  const { parentIndex } = useContext(RicosNodeContext);
  const { visibleIndentation } = useContext(VisibleIndentationContext);
  const firstChild = node.nodes[0];
  const dataProperty = `${firstChild?.type?.toLowerCase()}Data`;
  const { textAlignment } = firstChild?.[dataProperty]?.textStyle || {};
  const listStylePosition = textAlignment && textAlignment === TextStyle_TextAlignment.CENTER;
  const { parentNode } = useContext(RicosNodeContext);
  const indentation = visibleIndentation && visibleIndentation?.nodeId === parentNode?.id ? normalizeOffset(visibleIndentation?.indentation) : 0;
  const marginInlineStart = getStartMargin(parentNode, visibleIndentation?.indentation || 0);
  const marker = parentNode ? getListSymbol(indentation, parentNode.type) : "";
  const isParentOfHeading = firstChild?.type === Node_Type.HEADING;
  const headingLevel = isParentOfHeading && firstChild.headingData?.level;
  const listItemClassName = classnames(
    styles.listItem,
    isPaywallSeo(seoMode) && getPaywallSeoClass(seoMode?.paywall || {}, nodeIndex + parentIndex)
  );
  const childFontSize = firstChild?.nodes?.[0]?.textData?.decorations?.find(
    (decoration) => decoration.type === Decoration_Type.FONT_SIZE
  )?.fontSizeData?.value;
  return /* @__PURE__ */ React.createElement(
    "li",
    {
      dir: "auto",
      "aria-level": indentation + 1,
      className: listItemClassName,
      style: {
        textAlign: textAlignment,
        fontSize: childFontSize,
        marginInlineStart,
        listStyleType: marker
      },
      ...headingLevel ? { "data-heading-level": levelToClassName[headingLevel] } : {},
      ...listStylePosition ? { "data-list-style-position": "inside" } : {}
    },
    /* @__PURE__ */ React.createElement(RicosDirectionHandledContextProvider, { directionHandled: true }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: node, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: node.nodes ?? [], shouldParagraphApplyTextStyle: true })))
  );
};
const ListItemRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(ListItem, { key: node.id, node, ...props });
};
var listItem_default = ListItemRenderer;
export {
  listItem_default as default
};
//# sourceMappingURL=listItem.js.map
